import { PaperBox } from "../../../../components/Layout/PaperBox";
import { formatarDecimalNumber, formatarValorMonetario } from "../../../../helpers/masks";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { TFornecedorLeite } from "../../../../types/api/cadastros/pesquisar-movimentacao-publico";
import moment from "moment";
import { DadoValorPrinter } from "../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";

export default function CardFornecedorLeite({
    fornecedor
}: CardFornecedorLeiteProps) {

    const leiteArray = Object.values(fornecedor.leite).sort((a, b) => {
        return moment(b.data).diff(moment(a.data));
    });

    return (
        <PaperBox title="Fornecedor leite">
            <Grid container rowGap={2} mb={2}>
                <Grid size={{xs:4}}>
                    <DadoValorPrinter titulo="Desde" valor={moment(fornecedor.desde).format('MM/YYYY')} />
                </Grid>

                <Grid size={{xs:4}}>
                    <DadoValorPrinter titulo="Última entrega" valor={moment(fornecedor.ultima_entrega).format('MM/YYYY')} />
                </Grid>

                <Grid size={{xs:4}}>
                    <DadoValorPrinter titulo="Leite média mensal" valor={`${formatarDecimalNumber(fornecedor.qtd_media, 2)} Lts`} />
                </Grid>

                <Grid size={{xs:4}}>
                    <DadoValorPrinter titulo="Valor médio pago (bruto)" valor={formatarValorMonetario(fornecedor.media_bruta)} />
                </Grid>

                <Grid size={{xs:4}}>
                    <DadoValorPrinter titulo="Valor médio pago (líquido)" valor={formatarValorMonetario(fornecedor.media_liquida)} />
                </Grid>

            </Grid>
            {
                leiteArray.length > 0 &&
                <TableContainer sx={{ maxHeight: 400 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                {headers.map((item, index) => {
                                    return (
                                        <TableCell key={index} align={item.numeric ? 'right' : 'left'} sx={{ minWidth: item.width }}>
                                            <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                leiteArray.map((item, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={{ paddingX: 2 }}>
                                                {moment(item.data).format('MM/YYYY')}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {`${formatarDecimalNumber(item.quantidade)} Lts`}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {formatarValorMonetario(item.valor_bruto)}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {formatarValorMonetario(item.valor_liquido)}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </PaperBox>
    )
}

interface CardFornecedorLeiteProps {
    fornecedor: TFornecedorLeite;
}

const headers = [
    {
        label: "Data",
        numeric: false,
        width: '100%'
    },
    {
        label: "Quantidade",
        numeric: true,
        width: '100%'
    },
    {
        label: "Valor bruto",
        numeric: true,
        width: '100%'
    },
    {
        label: "Valor líquido",
        numeric: true,
        width: '140px'
    }
]
